async function postTrackSuggestion(fetchImpl, body) {
  const response = await fetchImpl("/api/indoorForm", {
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify(body),
  })
  const result = await response.json()

  if (!response.ok) {
    throw new Error(typeof result === "string" ? result : `Track submission failed (${response.status})`)
  }

  return result
}

module.exports = { postTrackSuggestion }
